<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import { SHORTCUTS } from '../../composables/useCsmlShortcuts';

const { t } = useI18n();
const dialogRef = ref(null);

const isMac =
  typeof navigator !== 'undefined' && /mac/i.test(navigator.platform || '');
const keyLabel = key => {
  if (key === 'Mod') return isMac ? '⌘' : 'Ctrl';
  if (key === 'Shift') return isMac ? '⇧' : 'Shift';
  return key;
};

const open = () => dialogRef.value?.open();
const close = () => dialogRef.value?.close();

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    width="md"
    :title="t('AGENT_BOTS.VISUAL_BUILDER.SHORTCUTS.TITLE')"
    :show-cancel-button="false"
    :confirm-button-label="t('AGENT_BOTS.VISUAL_BUILDER.SETTINGS.DONE')"
    @confirm="close"
  >
    <ul class="flex flex-col gap-1">
      <li
        v-for="shortcut in SHORTCUTS"
        :key="shortcut.id"
        class="flex items-center justify-between gap-4 py-1.5"
      >
        <span class="text-sm text-n-slate-12">
          {{ t(`AGENT_BOTS.VISUAL_BUILDER.SHORTCUTS.${shortcut.id}`) }}
        </span>
        <span class="flex items-center gap-1">
          <kbd
            v-for="key in shortcut.keys"
            :key="key"
            class="px-1.5 py-0.5 font-sans text-xs border rounded-md border-n-weak bg-n-alpha-2 text-n-slate-11"
          >
            {{ keyLabel(key) }}
          </kbd>
        </span>
      </li>
    </ul>
  </Dialog>
</template>
